"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopeRegistrar = void 0;
const React = require("react");
const store_context_1 = require("./store-context");
function defaultFallback(error) {
    return React.createElement("span", null, error ? error.message : 'Loading...');
}
exports.ScopeRegistrar = React.memo((props) => {
    const { addScope, removeScope } = React.useContext(store_context_1.RestateContext);
    const { scopeCreator, scopeName, persistent, children, fallback = defaultFallback } = props;
    const [state, setState] = React.useState({ canRender: false });
    React.useEffect(() => {
        const scope = addScope(scopeName, scopeCreator);
        const actions = scope.actions;
        if (actions && actions.initAsync) {
            actions.initAsync()
                .then(() => setState({ canRender: true }))
                .catch((error) => setState({ error }));
        }
        else {
            setState({ canRender: true });
        }
        return () => {
            if (persistent === true) {
                return;
            }
            removeScope(scopeName);
        };
    }, [addScope, removeScope]);
    return React.createElement(React.Fragment, null, state.canRender ? children : fallback(state.error));
});
//# sourceMappingURL=scope-registrar.js.map